<template>
  <div class="p-3 pt-5 mt-3 container text-center">
    <v-icon icon="done_all" size="3rem" color="var(--brand-color-hex)" />
    <h2 class="mb-0">{{ heading }}</h2>
    <p class="text-grey-70 mt-2">{{ description }}</p>
  </div>
</template>

<script>
export default {
  props: {
    icon: { type: String, default: "forum" },
    heading: { type: String, default: "" },
    description: { type: String, default: "" }
  }
}
</script>
